import { render, staticRenderFns } from "./ClientAccountComponent.vue?vue&type=template&id=96384880&"
import script from "./ClientAccountComponent.vue?vue&type=script&lang=js&"
export * from "./ClientAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports